import { useState } from "react";
import { useMapEvents } from "react-leaflet";

const useMapLoading = () => {
  const [isLoading, setIsLoading] = useState(true);

  const MapEventsHandler = () => {
    useMapEvents({
      load: () => setIsLoading(false),
      tileload: () => setIsLoading(false),
      tileloaderror: () => setIsLoading(false),
    });
    return null;
  };

  return { isLoading, setIsLoading, MapEventsHandler };
};

export default useMapLoading;
